var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.selectedpdf || !_vm.selectedpdf.file)?_c('h2',[_vm._v("No File Found")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }